module.exports = __webpack_public_path__ + "11e3b039a9aad1e0de5b6f778b4a8499.svg";